import type { FC } from "react";
import { Outlet } from "react-router-dom";

const TasksRoute: FC = () => {
  return <Outlet />;
};

export default TasksRoute;
